import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { IconFillColor, UnknownPersonIcon } from '@dreryk/react-components';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { calendarTranslationKeys } from '../../../../../../translations';

type AppointmentUnknownPatientInfoItemProps = {
   readonly patientReferenceIdentifier: PatientReferenceIdentifier | undefined;
};

export const AppointmentUnknownPatientInfoItem = (
   props: AppointmentUnknownPatientInfoItemProps
): JSX.Element | null => {
   if (props.patientReferenceIdentifier) {
      return null;
   }

   return (
      <AppointmentDetailsInfoItem
         testId={'unknownPatient'}
         content={calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.unknownPatient}
         icon={<UnknownPersonIcon />}
         iconFillColor={IconFillColor.ERROR}
      />
   );
};
